import React, {
  cloneElement,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Tooltip,
  Typography
} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import toastError from '../../errors/toastError'
import { i18nToast } from '../../helpers/i18nToast'
import useAuth from '../../hooks/useAuth.js'
import useCompanies from '../../hooks/useCompanies'
import useSettings from '../../hooks/useSettings'
import { InputFieldText } from '../InputFieldText'
import { InputSwitch } from '../InputSwitch'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {
  Bot,
  ChevronRight,
  Clock,
  ExternalLink,
  Files,
  Headset,
  Key,
  Lock,
  MessageSquareIcon,
  MoveRight,
  RefreshCw,
  Sparkles,
  Tag,
  Unlock,
  Users
} from 'lucide-react'
import { toast } from 'react-toastify'
import useQueues from '../../hooks/useQueues'
import { i18n } from '../../translate/i18n.js'
import api from '../../services/api'
import AlertDialog from '../AlertDialog'
import InputMessage from '../InputMessage'
import { QueueDepartmentSelect } from '../QueueDepartmentSelect/index.js'
import SchedulesForm from '../SchedulesForm/index.js'
import SelectInput from '../SelectInput'
import CompanyPixSettings from './CompanyPixSettings.js'
import { useStyles } from './styles.js'
import SectionAccordion from '../SectionAccordion/index.js'

// const SectionAccordion = React.memo(
//   ({ id, title, expanded, onChange, children, classes, extraHeader, icon }) => {
//     const isExpanded = expanded === id
//     return (
//       <Grid
//         item
//         xs={12}
//         className={classes.boxGrid}
//         component="section"
//         aria-labelledby={`${id}-title`}
//       >
//         <Accordion
//           expanded={isExpanded}
//           onChange={onChange(id)}
//           elevation={0}
//           className={classes.accordion}
//         >
//           <AccordionSummary
//             expandIcon={<ExpandMoreIcon />}
//             id={`${id}-header`}
//             aria-controls={`${id}-content`}
//             aria-expanded={isExpanded}
//           >
//             <div className={classes.groupContent}>
//               {icon && (
//                 <div className={classes.groupIcon} aria-hidden="true">
//                   {cloneElement(icon, { size: 18 })}
//                 </div>
//               )}
//               <h3 id={`${id}-title`} className={classes.groupTitle}>
//                 {title}
//               </h3>
//               {extraHeader}
//             </div>
//           </AccordionSummary>
//           <AccordionDetails
//             className={classes.accordionDetailsHighlighted}
//             id={`${id}-content`}
//             role="region"
//           >
//             <div style={{ width: '100%', marginTop: '10px' }}>{children}</div>
//           </AccordionDetails>
//         </Accordion>
//       </Grid>
//     )
//   }
// )

const HelpText = ({ children, id, className }) => {
  return (
    <Typography
      id={id}
      component="p"
      variant="body2"
      className={className}
      style={{ color: 'textSecondary', marginTop: '4px' }}
    >
      {children}
    </Typography>
  )
}

export default function Options(props) {
  const { settings } = props
  const classes = useStyles()
  const [expanded, setExpanded] = useState(false)

  const handleChange = useCallback(
    panel => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false)
    },
    []
  )

  //Estados dos Switches
  const [userRating, setUserRating] = useState('disabled')
  const [noQueueTimeoutSwitch, setNoQueueTimeoutSwitch] = useState('disabled')
  const [openTicketSwitch, setOpenTicketSwitch] = useState('disabled')
  const [activateChatbot, setActivateChatbot] = useState('disabled')
  const [activateOutOfHours, setActivateOutOfHours] = useState('disabled')
  const [activateResetNotifications, setActivateResetNotifications] =
    useState('disabled')
  const [ticketMessageSwitch, setTicketMessageSwitch] = useState('disabled')
  const [transferMessageSwitch, setTransferMessageSwitch] = useState('disabled')
  const [ticketAcceptedMessage, setTicketAcceptedMessage] = useState('')
  const [transferMessage, setTransferMessage] = useState('')
  const [excludeClosedTicketsSwitch, setExcludeClosedTicketsSwitch] =
    useState('disabled')
  const [delayPendingNotification, setDelayPendingNotification] =
    useState('disabled')

  const [scheduleType, setScheduleType] = useState('disabled')
  const [outOfHoursAction, setOutOfHoursAction] = useState('pending')
  const [outOfHoursQueueId, setOutOfHoursQueueId] = useState('')
  const [callType, setCallType] = useState('enabled')
  const [quickMessages, setQuickMessages] = useState('')
  const [chatbotAutoExit, setChatbotAutoExit] = useState('disabled')
  const [chatbotAutoExitQueueId, setChatbotAutoExitQueueId] = useState('')
  const [chatbotAutoExitAttempts, setChatbotAutoExitAttempts] = useState('1')

  const [CheckMsgIsGroup, setCheckMsgIsGroupType] = useState('enabled')
  const [soundGroupNotifications, setSoundGroupNotifications] =
    useState('disabled')
  const [groupsTab, setGroupsTab] = useState('disabled')
  const [messageVisibility, setMessageVisibility] = useState('message')

  const [noQueueTimeout, setNoQueueTimeout] = useState('0')
  const [noQueueTimeoutAction, setNoQueueTimeoutAction] = useState('0')
  const [openTicketTimeout, setOpenTicketTimeout] = useState('5')
  const [openTicketTimeoutAction, setOpenTicketTimeoutAction] =
    useState('pending')
  const [chatbotTicketTimeout, setChatbotTicketTimeout] = useState('0')
  const [chatbotTicketTimeoutAction, setChatbotTicketTimeoutAction] =
    useState(0)

  const [chatbotNotificationReset, setChatbotNotificationReset] = useState('0')
  const [pendingTicketPhoneDelay, setPendingTicketPhoneDelay] = useState('0')
  const [pendingTicketPhoneConnectionId, setPendingTicketPhoneConnectionId] =
    useState('')
  const [notificationResetStartDate, setNotificationResetStartDate] =
    useState('')
  const [notificationResetEndDate, setNotificationResetEndDate] = useState('')
  const [dailyTicketReset, setDailyTicketReset] = useState('disabled')

  const [queues, setQueues] = useState([])
  const [whatsApps, setWhatsApps] = useState([])
  const { findAll: findAllQueues } = useQueues()

  const [keepUserAndQueue, setKeepUserAndQueue] = useState('enabled')
  const [requireClosingReason, setRequireClosingReason] = useState('disabled')
  const [contactTicketHistory, setContactTicketHistory] = useState('disabled')
  const [ratingsTimeout, setRatingsTimeout] = useState(false)
  const [autoReopenTimeout, setAutoReopenTimeout] = useState(false)
  const [autoReopen, setAutoReopen] = useState('enabled')
  const [showSignatureButton, setShowSignatureButton] = useState('enabled')
  const [excludeClosedTicketsAfter, setExcludeClosedTicketsAfter] =
    useState('0')
  const [openAiKey, setOpenAiKey] = useState('')
  const [externalServicesLocked, setExternalServicesLocked] = useState(true)
  const [aiProvider, setAiProvider] = useState('openai')
  const [audioTranscriptions, setAudioTranscriptions] = useState('disabled')
  const [stuckAckWatchdogEnabled, setStuckAckWatchdogEnabled] =
    useState('enabled')
  const [stuckAckMinAgeMinutes, setStuckAckMinAgeMinutes] = useState('5')
  const [stuckAckMaxAgeMinutes, setStuckAckMaxAgeMinutes] = useState('20')
  const [stuckAckRefreshCooldownMinutes, setStuckAckRefreshCooldownMinutes] =
    useState('25')
  const [stuckAckReconnectWaitSeconds, setStuckAckReconnectWaitSeconds] =
    useState('20')
  const { getCurrentUserInfo } = useAuth()
  const [currentUser, setCurrentUser] = useState({})
  // "super" pode vir tanto pelo perfil quanto pela flag booleana dedicada
  const isSuperUser =
    currentUser?.super === true || currentUser?.profile === 'super'
  const { update } = useSettings()

  const [schedules, setSchedules] = useState([])
  const [company, setCompany] = useState({})
  const [loading, setLoading] = useState(false)
  const { find, updateSchedules } = useCompanies()

  const [confirmationOpen, setConfirmationOpen] = useState(false)
  const [modalMessage, setModalMessage] = useState('')

  const isMounted = useRef(true)
  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  const findRef = useRef(find)
  useEffect(() => {
    findRef.current = find
  }, [find])

  useEffect(() => {
    async function findData() {
      setLoading(true)
      try {
        const companyId = localStorage.getItem('companyId')
        const companyData = await findRef.current(companyId)
        if (isMounted.current) {
          setCompany(companyData)
          setSchedules(companyData.schedules)
        }
      } catch (e) {
        toast.error(e)
      } finally {
        if (isMounted.current) setLoading(false)
      }
    }
    findData()
  }, [])

  useEffect(() => {
    if (isMounted.current) {
      const loadQueues = async () => {
        const list = await findAllQueues({ includeOptions: true })
        // setQueues(list)
        const filteredQueues = list.filter(queue => !queue.isBot)
        setQueues(filteredQueues)
      }
      loadQueues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let mounted = true
    const loadWhatsApps = async () => {
      try {
        const { data } = await api.get('/whatsapp/?session=0')
        if (mounted) {
          setWhatsApps(data || [])
        }
      } catch (err) {
        toastError(err)
      }
    }
    loadWhatsApps()
    return () => {
      mounted = false
    }
  }, [])

  useEffect(() => {
    getCurrentUserInfo().then(u => setCurrentUser(u))

    // PERFORMANCE: Transforma o Array em Dicionário (O(1)) para evitar gargalos
    if (Array.isArray(settings) && settings.length) {
      const settingsMap = settings.reduce((acc, s) => {
        acc[s.key] = s.value
        return acc
      }, {})

      setUserRating(settingsMap.userRating || 'disabled')
      setScheduleType(settingsMap.scheduleType || 'disabled')
      setNoQueueTimeout(settingsMap.noQueueTimeout || '0')
      setOutOfHoursAction(settingsMap.outOfHoursAction || 'pending')
      setOutOfHoursQueueId(settingsMap.outOfHoursQueueId || '')
      setCallType(settingsMap.call || 'enabled')
      setCheckMsgIsGroupType(settingsMap.CheckMsgIsGroup || 'enabled')
      setSoundGroupNotifications(
        settingsMap.soundGroupNotifications || 'disabled'
      )
      setGroupsTab(settingsMap.groupsTab || 'disabled')
      setChatbotAutoExit(settingsMap.chatbotAutoExit || 'disabled')
      setChatbotAutoExitQueueId(settingsMap.chatbotAutoExitQueueId || '')
      setChatbotAutoExitAttempts(settingsMap.chatbotAutoExitAttempts || '1')
      setQuickMessages(settingsMap.quickMessages || 'individual')
      setKeepUserAndQueue(settingsMap.keepUserAndQueue || 'enabled')
      setRequireClosingReason(settingsMap.requireClosingReason || 'disabled')
      setContactTicketHistory(settingsMap.contactTicketHistory || 'disabled')
      setOpenAiKey(settingsMap.openAiKey || '')
      setAiProvider(settingsMap.aiProvider || 'openai')
      setAudioTranscriptions(settingsMap.audioTranscriptions || 'disabled')
      setMessageVisibility(settingsMap.messageVisibility || 'message')
      setRatingsTimeout(settingsMap.ratingsTimeout || '1')
      setAutoReopenTimeout(settingsMap.autoReopenTimeout || '0')
      setAutoReopen(settingsMap.autoReopen || 'enabled')
      setNoQueueTimeoutAction(settingsMap.noQueueTimeoutAction || '0')
      setOpenTicketTimeout(settingsMap.openTicketTimeout || '5')
      setOpenTicketTimeoutAction(
        settingsMap.openTicketTimeoutAction || 'pending'
      )
      setChatbotTicketTimeout(settingsMap.chatbotTicketTimeout || '0')
      setChatbotTicketTimeoutAction(
        settingsMap.chatbotTicketTimeoutAction || '0'
      )
      setChatbotNotificationReset(settingsMap.chatbotNotificationReset || '0')
      setPendingTicketPhoneDelay(settingsMap.pendingTicketPhoneDelay || '0')
      setPendingTicketPhoneConnectionId(
        settingsMap.pendingTicketPhoneConnectionId || ''
      )
      setNotificationResetStartDate(
        settingsMap.notificationResetStartDate || ''
      )
      setNotificationResetEndDate(settingsMap.notificationResetEndDate || '')
      setDailyTicketReset(settingsMap.dailyTicketReset || 'disabled')
      setShowSignatureButton(settingsMap.showSignatureButton || 'enabled')
      setExcludeClosedTicketsAfter(settingsMap.excludeClosedTicketsAfter || '0')
      setTicketAcceptedMessage(settingsMap.ticketAcceptedMessage || '')
      setTransferMessage(settingsMap.transferMessage || '')
      setStuckAckWatchdogEnabled(
        settingsMap.stuckAckWatchdogEnabled || 'enabled'
      )
      setStuckAckMinAgeMinutes(settingsMap.stuckAckMinAgeMinutes || '5')
      setStuckAckMaxAgeMinutes(settingsMap.stuckAckMaxAgeMinutes || '20')
      setStuckAckRefreshCooldownMinutes(
        settingsMap.stuckAckRefreshCooldownMinutes || '25'
      )
      setStuckAckReconnectWaitSeconds(
        settingsMap.stuckAckReconnectWaitSeconds || '20'
      )

      // Keep switch UI always synced with persisted backend settings.
      const isEnabledValue = value => {
        if (value === undefined || value === null) return false
        const normalized = String(value).trim()
        return (
          normalized !== '' && normalized !== '0' && normalized !== 'disabled'
        )
      }

      const noQueueSwitchValue = isEnabledValue(settingsMap.noQueueTimeout)
      setNoQueueTimeoutSwitch(noQueueSwitchValue ? 'enabled' : 'disabled')
      const openTicketSwitchValue = isEnabledValue(
        settingsMap.openTicketTimeout
      )
      setOpenTicketSwitch(openTicketSwitchValue ? 'enabled' : 'disabled')
      const chatbotSwitchValue = isEnabledValue(
        settingsMap.chatbotTicketTimeout
      )
      setActivateChatbot(chatbotSwitchValue ? 'enabled' : 'disabled')
      const resetNotificationsSwitchValue = isEnabledValue(
        settingsMap.chatbotNotificationReset
      )
      setActivateResetNotifications(
        resetNotificationsSwitchValue ? 'enabled' : 'disabled'
      )
      const ticketMessageSwitchValue = isEnabledValue(
        settingsMap.ticketAcceptedMessage
      )
      setTicketMessageSwitch(ticketMessageSwitchValue ? 'enabled' : 'disabled')
      const transferMessageSwitchValue = isEnabledValue(
        settingsMap.transferMessage
      )
      setTransferMessageSwitch(
        transferMessageSwitchValue ? 'enabled' : 'disabled'
      )
      const excludeClosedSwitchValue = isEnabledValue(
        settingsMap.excludeClosedTicketsAfter
      )
      setExcludeClosedTicketsSwitch(
        excludeClosedSwitchValue ? 'enabled' : 'disabled'
      )
      const outOfHoursSwitchValue =
        String(settingsMap.outOfHoursAction || '').trim() !== '' &&
        String(settingsMap.outOfHoursAction || '0') !== '0'
      setActivateOutOfHours(outOfHoursSwitchValue ? 'enabled' : 'disabled')

      const hasDelayConfigured = isEnabledValue(
        settingsMap.pendingTicketPhoneDelay
      )
      setDelayPendingNotification(hasDelayConfigured ? 'enabled' : 'disabled')
      setPendingTicketPhoneDelay(settingsMap.pendingTicketPhoneDelay || '0')
    }
  }, [settings])

  const chatbotAutoExitQueues = useMemo(() => {
    if (!Array.isArray(queues)) return []
    return queues.filter(queue => {
      const queueName = String(queue?.name || '')
        .trim()
        .toLowerCase()
      const hasSubDepartments =
        Array.isArray(queue?.options) && queue.options.length > 0
      const isSubDepartment = Number(queue?.nivel) === 2

      return (
        Number(queue?.id) > 0 &&
        queueName !== 'manter departamento atual' &&
        (!hasSubDepartments || isSubDepartment)
      )
    })
  }, [queues])

  const outOfHoursQueueOptions = useMemo(() => {
    if (!Array.isArray(queues) || scheduleType !== 'queue') return null
    return [
      {
        id: 'automatic',
        name: i18n.t('settings.outOfHoursAction.options.automatic'),
        isBot: false
      },
      ...queues.filter(queue => {
        const hasSubDepartments =
          Array.isArray(queue?.options) && queue.options.length > 0
        const isSubDepartment = Number(queue?.nivel) === 2

        return !queue.isBot && (!hasSubDepartments || isSubDepartment)
      })
    ]
  }, [queues, scheduleType])

  const outOfHoursQueueValue = useMemo(() => {
    if (outOfHoursQueueId === '' || outOfHoursQueueId === 'automatic') {
      return outOfHoursQueueOptions ? [outOfHoursQueueOptions[0]] : []
    }
    return (outOfHoursQueueOptions || queues).filter(
      q => String(q.id) === String(outOfHoursQueueId)
    )
  }, [outOfHoursQueueId, outOfHoursQueueOptions, queues])

  const defaultWhatsAppConnectionId = useMemo(() => {
    if (!Array.isArray(whatsApps)) return ''
    const defaultWhatsapp = whatsApps.find(whatsApp => whatsApp.isDefault)
    return defaultWhatsapp ? String(defaultWhatsapp.id) : ''
  }, [whatsApps])

  const pendingTicketPhoneConnectionValue = useMemo(() => {
    return pendingTicketPhoneConnectionId || defaultWhatsAppConnectionId || ''
  }, [pendingTicketPhoneConnectionId, defaultWhatsAppConnectionId])

  const handleSetting = useCallback(
    async (key, value, setter = null) => {
      if (setter) setter(value)
      await update({
        key,
        value
      })
      i18nToast.success('settings.success')
    },
    [update]
  )
  const handleSubmitSchedules = async data => {
    setLoading(true)
    try {
      setSchedules(data)
      await updateSchedules({ id: company.id, schedules: data })
      toast.success('Horários atualizados com sucesso.')
      const companySchedulesConfigured = data && data.some(s => s.startTimeA)
      if (scheduleType === 'company' && !companySchedulesConfigured) {
        setActivateOutOfHours('disabled')
        localStorage.setItem('activeOutOfHours', 'disabled')
      }
    } catch (e) {
      toast.error(e)
    }
    setLoading(false)
  }
  const handleChangeUserRating = async value => {
    if (value === 'enabled' && userRating === 'disabled') {
      setRatingsTimeout('1')
      await update({
        key: 'ratingsTimeout',
        value: '1'
      })
    } else if (value === 'disabled') {
      setRatingsTimeout('')
      await update({
        key: 'ratingsTimeout',
        value: ''
      })
    }
    setUserRating(value)
    await update({
      key: 'userRating',
      value
    })
    i18nToast.success('settings.success')
  }
  const handleScheduleTypeChange = value => {
    setScheduleType(value)
    if (value === 'disabled') {
      setActivateOutOfHours('disabled')
      localStorage.setItem('activeOutOfHours', 'disabled')
    }
  }
  const handleChatbotAutoExit = async value => {
    if (
      value === 'enabled' &&
      Array.isArray(chatbotAutoExitQueues) &&
      chatbotAutoExitQueues.length > 0 &&
      (!chatbotAutoExitQueueId ||
        !chatbotAutoExitQueues.some(
          queue => String(queue.id) === String(chatbotAutoExitQueueId)
        ))
    ) {
      const defaultQueueId = String(chatbotAutoExitQueues[0].id)
      setChatbotAutoExitQueueId(defaultQueueId)
      await update({
        key: 'chatbotAutoExitQueueId',
        value: defaultQueueId
      })
    } else if (value === 'disabled') {
      setChatbotAutoExitQueueId('')
      await update({ key: 'chatbotAutoExitQueueId', value: '' })
    }

    if (value === 'enabled' && !chatbotAutoExitAttempts) {
      setChatbotAutoExitAttempts('1')
      await update({ key: 'chatbotAutoExitAttempts', value: '1' })
    }

    setChatbotAutoExit(value)
    await update({
      key: 'chatbotAutoExit',
      value
    })
    i18nToast.success('settings.success')
  }
  const handleAutoReopen = async value => {
    if (value === 'enabled' && autoReopen === 'disabled') {
      setAutoReopenTimeout('0')
      await update({
        key: 'autoReopenTimeout',
        value: '0'
      })
    } else if (value === 'disabled') {
      setAutoReopenTimeout('0')
      await update({ key: 'autoReopenTimeout', value: '0' })
    }
    setAutoReopen(value)
    await update({
      key: 'autoReopen',
      value
    })
    i18nToast.success('settings.success')
  }
  const handleGroupType = async value => {
    setCheckMsgIsGroupType(value)
    await update({
      key: 'CheckMsgIsGroup',
      value
    })

    if (value === 'disabled') {
      setSoundGroupNotifications('enabled')
      await update({
        key: 'soundGroupNotifications',
        value: 'enabled'
      })
      setGroupsTab('enabled')
      await update({
        key: 'groupsTab',
        value: 'enabled'
      })
    } else {
      setSoundGroupNotifications('disabled')
      await update({
        key: 'soundGroupNotifications',
        value: 'disabled'
      })
      setGroupsTab('disabled')
      await update({
        key: 'groupsTab',
        value: 'disabled'
      })
    }

    i18nToast.success('settings.success')
    /* if (typeof scheduleTypeChanged === "function") {
          scheduleTypeChanged(value);
        } */
  }
  const handleTicketMessageSwitch = useCallback(
    async value => {
      setTicketMessageSwitch(value)
      // localStorage.setItem('ticketMessageSwitch', value)
      if (value === 'disabled') {
        setTicketAcceptedMessage('')
        await update({
          key: 'ticketAcceptedMessage',
          value: ''
        })
      }
    },
    [update]
  )
  const handleTransferMessageSwitch = useCallback(
    async value => {
      setTransferMessageSwitch(value)
      if (value === 'disabled') {
        setTransferMessage('')
        await update({
          key: 'transferMessage',
          value: ''
        })
      }
    },
    [update]
  )
  const handleNoQueueTimeoutSwitch = async value => {
    setNoQueueTimeoutSwitch(value)
    localStorage.setItem('noQueueTimeoutSwitch', value)
    if (value === 'disabled') {
      setNoQueueTimeout('0')
      setNoQueueTimeoutAction('0')
      await update({ key: 'noQueueTimeout', value: '' })
      await update({ key: 'noQueueTimeoutAction', value: '' })
    }
  }
  const handleOpenTicketSwitch = async value => {
    setOpenTicketSwitch(value)
    localStorage.setItem('openTicketSwitch', value)
    if (value === 'disabled') {
      setOpenTicketTimeout('0')
      setOpenTicketTimeoutAction('0')
      await update({ key: 'openTicketTimeout', value: '' })
      await update({ key: 'openTicketTimeoutAction', value: '' })
    }
  }
  const handleActivateChatbotSwitch = async value => {
    setActivateChatbot(value)
    localStorage.setItem('activateChatbot', value)
    if (value === 'disabled') {
      setChatbotTicketTimeout('0')
      setChatbotTicketTimeoutAction('0')
      await update({ key: 'chatbotTicketTimeout', value: '' })
      await update({ key: 'chatbotTicketTimeoutAction', value: '' })
    }
  }
  const handleActivateOutOfHours = async value => {
    if (value === 'enabled') {
      const companySchedulesConfigured =
        scheduleType === 'company' &&
        schedules &&
        schedules.some(s => s.startTimeA)

      const departmentSchedulesConfigured =
        scheduleType === 'queue' &&
        queues &&
        queues.some(
          q => Array.isArray(q.schedules) && q.schedules.some(s => s.startTimeA)
        )

      if (
        scheduleType === 'disabled' ||
        (!companySchedulesConfigured && !departmentSchedulesConfigured)
      ) {
        setModalMessage(
          "Para habilitar a opção 'Fora do Expediente', é necessário configurar os horários de atendimento para a empresa ou para os departamentos."
        )
        setConfirmationOpen(true)
        return
      }

      const action = outOfHoursAction || 'pending'
      await update({
        key: 'outOfHoursAction',
        value: action
      })
      if (outOfHoursAction !== action) {
        setOutOfHoursAction(action)
      }

      // Garante que outOfHoursQueueId esteja definido ao ativar
      // Quando o expediente é por departamento, o padrão é manter o atual (automático).
      const firstNonBotQueue = queues.find(q => !q.isBot)
      const effectiveQueueId =
        scheduleType === 'queue'
          ? outOfHoursQueueId || 'automatic'
          : outOfHoursQueueId || String(firstNonBotQueue?.id || '')
      if (outOfHoursQueueId !== effectiveQueueId) {
        setOutOfHoursQueueId(effectiveQueueId)
        await update({
          key: 'outOfHoursQueueId',
          value: effectiveQueueId
        })
      }
    }

    if (value === 'disabled') {
      await update({
        key: 'outOfHoursAction',
        value: '0'
      })
      setOutOfHoursAction('0')
    }

    setActivateOutOfHours(value)
    localStorage.setItem('activeOutOfHours', value)
  }
  const handleExcludeClosedTicketsSwitch = async value => {
    setExcludeClosedTicketsSwitch(value)
    localStorage.setItem('excludeClosedTicketsSwitch', value)

    if (value === 'disabled') {
      setExcludeClosedTicketsAfter('')

      try {
        await update({
          key: 'excludeClosedTicketsAfter',
          value: ''
        })
        i18nToast.success('Configuração de tempo limpa com sucesso.')
      } catch (err) {
        toastError(err)
      }
    }
  }
  const handleActivateResetNotificationsSwitch = async value => {
    setActivateResetNotifications(value)
    localStorage.setItem('activateResetNotifications', value)
    if (value === 'enabled') {
      // Define 08:00 para Início e 18:00 para Fim
      const startTime = '08:00'
      const endTime = '18:00'
      const timeReset = '5'

      setNotificationResetStartDate(startTime)
      setNotificationResetEndDate(endTime)
      setChatbotNotificationReset(timeReset)
      // Salva os novos valores no backend/settings
      await update({
        key: 'notificationResetStartDate',
        value: startTime
      })
      await update({
        key: 'notificationResetEndDate',
        value: endTime
      })
      await update({ key: 'chatbotNotificationReset', value: timeReset })
    } else {
      setNotificationResetStartDate('')
      setNotificationResetEndDate('')
      setChatbotNotificationReset('')
      await update({
        key: 'notificationResetStartDate',
        value: ''
      })
      await update({
        key: 'notificationResetEndDate',
        value: ''
      })
      await update({ key: 'chatbotNotificationReset', value: '' })
    }
  }
  const handleCallType = async value => {
    setCallType(value)
    await update({
      key: 'call',
      value
    })
    i18nToast.success('settings.success')
  }
  const handleQuickMessages = async value => {
    setQuickMessages(value)
    await update({
      key: 'quickMessages',
      value
    })
    i18nToast.success('settings.success')
  }
  const handleTimeChange = (e, setter) => {
    setter(e.target.value)
    e.target.blur()
  }
  const handleDelayPendingNotificationSwitch = async value => {
    setDelayPendingNotification(value)
    if (value === 'disabled') {
      setPendingTicketPhoneDelay('0')
      await update({ key: 'pendingTicketPhoneDelay', value: '' })
    }
  }

  return (
    <>
      <AlertDialog
        title={'Atenção'}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
      >
        {modalMessage}
      </AlertDialog>
      <Grid container>
        <SectionAccordion
          id="panel1"
          title={i18n.t('settings.group.general')}
          expanded={expanded}
          onChange={handleChange}
          classes={classes}
          icon={<MessageSquareIcon />}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} className={classes.boxContentInputMessage}>
              <Grid xs={12} md={6} item className={classes.boxContentGroup}>
                <InputSwitch
                  label={'Mensagem de Saudação'}
                  name="ticketMessageSwitch"
                  id="ticketMessageSwitch"
                  checked={ticketMessageSwitch === 'enabled'}
                  onChange={e => {
                    handleTicketMessageSwitch(
                      e.target.checked ? 'enabled' : 'disabled'
                    )
                  }}
                />
                {ticketMessageSwitch === 'enabled' && (
                  <>
                    <InputMessage
                      label={
                        'Mensagem de saudação padrão para departamentos sem mensagem definida'
                      }
                      value={ticketAcceptedMessage}
                      onChange={e => setTicketAcceptedMessage(e.target.value)}
                      onBlur={e => {
                        handleSetting(
                          'ticketAcceptedMessage',
                          ticketAcceptedMessage
                        )
                      }}
                      placeholder={
                        'Olá! Bem-vindo ao [Nome da Empresa]. Como posso ajudar você hoje?'
                      }
                      isLarge
                    />
                    <span className={classes.description}>
                      Caso o departamento já possua mensagem de saudação
                      configurada, ela terá prioridade e esta será ignorada.
                    </span>
                  </>
                )}
              </Grid>
              <Grid xs={12} md={6} item className={classes.boxContentGroup}>
                <InputSwitch
                  label={'Mensagem de Transferência'}
                  name="transferMessageSwitch"
                  id="transferMessageSwitch"
                  checked={transferMessageSwitch === 'enabled'}
                  onChange={e => {
                    handleTransferMessageSwitch(
                      e.target.checked ? 'enabled' : 'disabled'
                    )
                  }}
                />
                {transferMessageSwitch === 'enabled' && (
                  <>
                    <InputMessage
                      label={
                        'Mensagem de transferência padrão para departamentos sem mensagem definida'
                      }
                      value={transferMessage}
                      onChange={e => {
                        setTransferMessage(e.target.value)
                      }}
                      onBlur={e => {
                        handleSetting('transferMessage', transferMessage)
                      }}
                      placeholder={
                        'Aguarde um momento que seu atendimento foi transferido.'
                      }
                      isLarge
                    />
                    <span className={classes.description}>
                      Caso o departamento já possua mensagem de transferência
                      configurada, ela terá prioridade e esta será ignorada.
                    </span>
                  </>
                )}
              </Grid>
            </Grid>

            <Grid item xs={12} className={classes.boxContentInputMessage}>
              <Grid item xs={12} md={2} className={classes.boxContentGroup}>
                <InputSwitch
                  label={i18n.t('settings.VoiceAndVideoCalls.title')}
                  name="voiceAndVideoCalls"
                  id="voiceAndVideoCalls"
                  checked={callType === 'enabled'}
                  onChange={e => {
                    handleCallType(e.target.checked ? 'enabled' : 'disabled')
                  }}
                />

                <HelpText
                  id="voiceAndVideoCalls-helper"
                  className={classes.helpText}
                >
                  Ao ativar notifica a indisponibilidade de serviço. Se
                  desativado apenas ignora
                </HelpText>
              </Grid>

              <Grid item xs={12} md={2} className={classes.boxContentGroup}>
                <InputSwitch
                  label="Tipo de Mensagem Rápida"
                  name="quickMessages"
                  id="quickMessages"
                  checked={quickMessages === 'company'}
                  onChange={e => {
                    handleQuickMessages(
                      e.target.checked ? 'company' : 'individual'
                    )
                  }}
                />
                <HelpText
                  id="quickMessages-helper"
                  className={classes.helpText}
                >
                  Ativado: Empresa, visível pra todos Desativado; por usuário,
                  somente quem criou pode ver.
                </HelpText>
              </Grid>

              <Grid item xs={12} md={2} className={classes.boxContentGroup}>
                <InputSwitch
                  label="Gerenciar Assinatura"
                  name="showSignatureButton"
                  id="showSignatureButton"
                  checked={showSignatureButton === 'disabled'}
                  onChange={e => {
                    handleSetting(
                      'showSignatureButton',
                      e.target.checked ? 'disabled' : 'enabled',
                      setShowSignatureButton
                    )
                  }}
                />
                <HelpText
                  id="signatureButton-helper"
                  className={classes.helpText}
                >
                  Ativado: todos os usuários enviaram mensagem com assinatura e
                  oculta o botão.
                </HelpText>
              </Grid>

            </Grid>
          </Grid>
        </SectionAccordion>

        <SectionAccordion
          id="panel2"
          title={i18n.t('settings.group.timeouts')}
          expanded={expanded}
          onChange={handleChange}
          classes={classes}
          icon={<Headset />}
        >
          <Grid container>
            <Grid item xs={12} className={classes.boxContentInput}>
              <Grid
                item
                xs={12}
                md={3}
                className={classes.boxContentGroup}
                style={{
                  maxHeight: userRating === 'enabled' ? '250px' : '110px'
                }}
              >
                <div className={classes.helpButton}>
                  <InputSwitch
                    label="Avaliações"
                    checked={userRating === 'enabled'}
                    onChange={e => {
                      handleChangeUserRating(
                        e.target.checked ? 'enabled' : 'disabled'
                      )
                    }}
                  />
                </div>

                <HelpText id="avaliacoes-helper" className={classes.helpText}>
                  Ativado todos os atendimentos serão avaliados dentro do tempo
                  determinado depois de encerrado.
                </HelpText>

                {userRating === 'enabled' && (
                  <div className={classes.selectTempo}>
                    <SelectInput
                      label="Tempo"
                      value={ratingsTimeout || '1'}
                      onChange={async e => {
                        handleSetting(
                          'ratingsTimeout',
                          e.target.value,
                          setRatingsTimeout
                        )
                      }}
                    >
                      <MenuItem value={'1'}>1min</MenuItem>
                      <MenuItem value={'5'}>5min</MenuItem>
                      <MenuItem value={'10'}>10min</MenuItem>
                      <MenuItem value={'15'}>15min</MenuItem>
                      <MenuItem value={'30'}>30min</MenuItem>
                      <MenuItem value={'60'}>1h</MenuItem>
                    </SelectInput>
                  </div>
                )}
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                className={classes.boxContentGroup}
                style={{
                  maxHeight: autoReopen === 'enabled' ? '250px' : '110px'
                }}
              >
                <div className={classes.helpButton}>
                  <InputSwitch
                    label="Reabertura"
                    checked={autoReopen === 'enabled'}
                    onChange={e => {
                      handleAutoReopen(
                        e.target.checked ? 'enabled' : 'disabled'
                      )
                    }}
                  />
                </div>

                <HelpText id="autoReopen-helper" className={classes.helpText}>
                  Ativado permite definir um tempo para novo atendimento. Se
                  desativado fica instantâneo.
                </HelpText>

                {autoReopen === 'enabled' && (
                  <div className={classes.selectTempoReopen}>
                    <SelectInput
                      label="Tempo"
                      value={autoReopenTimeout || '0'}
                      onChange={async e => {
                        handleSetting(
                          'autoReopenTimeout',
                          e.target.value,
                          setAutoReopenTimeout
                        )
                      }}
                    >
                      <MenuItem value={'0'}>Padrão</MenuItem>
                      <MenuItem value={'5'}>5min</MenuItem>
                      <MenuItem value={'10'}>10min</MenuItem>
                      <MenuItem value={'15'}>15min</MenuItem>
                      <MenuItem value={'30'}>30min</MenuItem>
                      <MenuItem value={'60'}>1h</MenuItem>
                    </SelectInput>
                  </div>
                )}
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                className={classes.boxContentGroup}
                style={{
                  maxHeight:
                    excludeClosedTicketsSwitch === 'enabled' ? '250px' : '110px'
                }}
              >
                <div className={classes.helpButton}>
                  <InputSwitch
                    label="Mensagem temporária"
                    checked={excludeClosedTicketsSwitch === 'enabled'}
                    onChange={e => {
                      handleExcludeClosedTicketsSwitch(
                        e.target.checked ? 'enabled' : 'disabled'
                      )
                    }}
                  />
                </div>
                <HelpText
                  id="excludeClosedTickets-helper"
                  className={classes.helpText}
                >
                  Ao ativar as mensagens de todos os atendentes serão excluídas
                  no prazo determinado.
                </HelpText>

                {excludeClosedTicketsSwitch === 'enabled' && (
                  <SelectInput
                    label="Tempo (dias)"
                    value={excludeClosedTicketsAfter}
                    style={{ maxWidth: '115px' }}
                    onChange={async e => {
                      const newValue = e.target.value
                      setExcludeClosedTicketsAfter(newValue)
                      await handleSetting(
                        'excludeClosedTicketsAfter',
                        Number(newValue)
                      )
                    }}
                  >
                    <MenuItem value={15}>15 dias</MenuItem>
                    <MenuItem value={30}>30 dias</MenuItem>
                    <MenuItem value={90}>90 dias</MenuItem>
                    <MenuItem value={180}>06 meses</MenuItem>
                    <MenuItem value={365}>1 ano</MenuItem>
                  </SelectInput>
                )}
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                className={classes.boxContentGroup}
                style={{
                  maxHeight: dailyTicketReset === 'enabled' ? '270px' : '110px'
                }}
              >
                <div className={classes.helpButton}>
                  <InputSwitch
                    label="Ação Diária"
                    checked={dailyTicketReset === 'enabled'}
                    onChange={e => {
                      handleSetting(
                        'dailyTicketReset',

                        e.target.checked ? 'enabled' : 'disabled',

                        setDailyTicketReset
                      )
                    }}
                  />
                </div>

                <HelpText
                  id="dailyTicketReset-helper"
                  className={classes.helpText}
                >
                  Automatiza a mudança de status dos atendimentos abertos para
                  pendente após às 00:00 do dia.
                </HelpText>
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                className={classes.boxContentGroup}
                style={{
                  maxHeight:
                    noQueueTimeoutSwitch === 'enabled' ? '270px' : '110px'
                }}
              >
                <div className={classes.helpButton}>
                  <InputSwitch
                    label="Sem Departamento"
                    checked={noQueueTimeoutSwitch === 'enabled'}
                    onChange={e => {
                      handleNoQueueTimeoutSwitch(
                        e.target.checked ? 'enabled' : 'disabled'
                      )
                    }}
                  />
                </div>
                <HelpText
                  id="noQueueTimeout-helper"
                  className={classes.helpText}
                >
                  Ao ativar você define qual ação tomar em X minutos com
                  atendimentos sem departamentos.
                </HelpText>
                {noQueueTimeoutSwitch === 'enabled' && (
                  <div className={classes.boxInputTransition}>
                    <div className={classes.selectTempo}>
                      <SelectInput
                        label="Tempo"
                        value={noQueueTimeout || '5'}
                        onChange={async e => {
                          handleSetting(
                            'noQueueTimeout',
                            e.target.value,
                            setNoQueueTimeout
                          )
                        }}
                      >
                        <MenuItem value={'5'}>5min</MenuItem>
                        <MenuItem value={'10'}>10min</MenuItem>
                        <MenuItem value={'15'}>15min</MenuItem>
                        <MenuItem value={'30'}>30min</MenuItem>
                        <MenuItem value={'60'}>1h</MenuItem>
                      </SelectInput>
                    </div>

                    <div className={classes.selectAcao}>
                      <SelectInput
                        label="Ação"
                        value={noQueueTimeoutAction}
                        onChange={async e => {
                          handleSetting(
                            'noQueueTimeoutAction',
                            e.target.value,
                            setNoQueueTimeoutAction
                          )
                        }}
                      >
                        <MenuItem value={'0'}>Fechar</MenuItem>

                        {queues
                          .filter(queue => {
                            const hasSubDepartments =
                              Array.isArray(queue?.options) &&
                              queue.options.length > 0
                            const isSubDepartment = Number(queue?.nivel) === 2

                            return !hasSubDepartments || isSubDepartment
                          })
                          .map(queue => (
                            <MenuItem
                              key={queue.id}
                              value={queue.id}
                              className={classes.menuItem}
                            >
                              {/* <ChevronRight size={18} /> */}

                              {queue.name}
                            </MenuItem>
                          ))}
                      </SelectInput>
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>

            <Grid item xs={12} className={classes.boxContentInput}>
              <Grid
                item
                xs={12}
                md={3}
                className={classes.boxContentGroup}
                style={{
                  maxHeight: openTicketSwitch === 'enabled' ? '270px' : '110px'
                }}
              >
                <div className={classes.helpButton}>
                  <InputSwitch
                    label="Em Aberto"
                    checked={openTicketSwitch === 'enabled'}
                    onChange={e => {
                      handleOpenTicketSwitch(
                        e.target.checked ? 'enabled' : 'disabled'
                      )
                    }}
                  />
                </div>

                <HelpText id="openTicket-helper" className={classes.helpText}>
                  Ao ativar você define qual ação tomar em X minutos com
                  atendimentos sem interação.
                </HelpText>

                {openTicketSwitch === 'enabled' && (
                  <div className={classes.boxInputTransition}>
                    <div className={classes.selectTempo}>
                      <SelectInput
                        label="Tempo"
                        value={openTicketTimeout || '5'}
                        onChange={async e => {
                          handleSetting(
                            'openTicketTimeout',
                            e.target.value,
                            setOpenTicketTimeout
                          )
                        }}
                      >
                        <MenuItem value={'20'}>20min</MenuItem>
                        <MenuItem value={'30'}>30min</MenuItem>
                        <MenuItem value={'60'}>1h</MenuItem>
                        <MenuItem value={'120'}>2h</MenuItem>
                        <MenuItem value={'180'}>3h</MenuItem>
                      </SelectInput>
                    </div>

                    <div className={classes.selectAcao}>
                      <SelectInput
                        label="Ação"
                        value={openTicketTimeoutAction}
                        onChange={async e => {
                          handleSetting(
                            'openTicketTimeoutAction',
                            e.target.value,
                            setOpenTicketTimeoutAction
                          )
                        }}
                      >
                        <MenuItem value={'pending'}>Retornar</MenuItem>
                        <MenuItem value={'closed'}>Fechar</MenuItem>
                      </SelectInput>
                    </div>
                  </div>
                )}
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                className={classes.boxContentGroup}
                style={{
                  maxHeight:
                    activateResetNotifications === 'enabled' ? '270px' : '110px'
                }}
              >
                <div className={classes.helpButton}>
                  <InputSwitch
                    // label={i18n.t('settings.dailyTicketReset.title')}
                    label="Repetir Notificação"
                    checked={activateResetNotifications === 'enabled'}
                    onChange={e => {
                      handleActivateResetNotificationsSwitch(
                        e.target.checked ? 'enabled' : 'disabled'
                      )
                    }}
                  />
                </div>
                <HelpText
                  id="activateResetNotifications-helper"
                  className={classes.helpText}
                >
                  O aviso sonoro de atendimentos não visualizados será repetido
                  a cada X minutos no período definido.
                </HelpText>

                {activateResetNotifications === 'enabled' && (
                  <div className={classes.boxInputTransition}>
                    <div className={classes.selectTempo}>
                      <SelectInput
                        label="Tempo"
                        value={chatbotNotificationReset || '5'}
                        onChange={async e => {
                          handleSetting(
                            'chatbotNotificationReset',
                            e.target.value,
                            setChatbotNotificationReset
                          )
                        }}
                      >
                        <MenuItem value={'5'}>5min</MenuItem>
                        <MenuItem value={'10'}>10min</MenuItem>
                        <MenuItem value={'15'}>15min</MenuItem>
                      </SelectInput>
                    </div>
                    <InputFieldText
                      label="Início"
                      type="time"
                      value={notificationResetStartDate}
                      onChange={e => {
                        handleTimeChange(e, setNotificationResetStartDate)
                      }}
                      onBlur={async _ => {
                        await handleSetting(
                          'notificationResetStartDate',
                          notificationResetStartDate
                        )
                      }}
                    />
                    <InputFieldText
                      label="Fim"
                      type="time"
                      value={notificationResetEndDate}
                      onChange={e => {
                        handleTimeChange(e, setNotificationResetEndDate)
                      }}
                      onBlur={async _ => {
                        await handleSetting(
                          'notificationResetEndDate',
                          notificationResetEndDate
                        )
                      }}
                    />
                  </div>
                )}
              </Grid>

              <Grid item xs={12} md={3} className={classes.boxContentGroup}>
                <div className={classes.helpButton}>
                  <InputSwitch
                    label="Delay de Notificação Pendente"
                    name="delayPendingNotification"
                    id="delayPendingNotification"
                    checked={delayPendingNotification === 'enabled'}
                    onChange={e => {
                      handleDelayPendingNotificationSwitch(
                        e.target.checked ? 'enabled' : 'disabled'
                      )
                    }}
                    inputProps={{
                      'aria-describedby': 'pendingTicketPhoneDelay-helper'
                    }}
                  />
                </div>
                <HelpText
                  id="pendingTicketPhoneDelay-helper"
                  className={classes.helpText}
                >
                  Aguardar X minutos antes de enviar a mensagem para o telefone
                  do atendente quando um atendimento cair em pendente. Se o
                  atendimento sair do departamento antes do tempo, a mensagem não será
                  enviada. Use 0 para enviar imediatamente.
                </HelpText>

                {delayPendingNotification === 'enabled' && (
                  <div className={classes.selectTempo}>
                    <SelectInput
                      label="Tempo"
                      value={pendingTicketPhoneDelay || '5'}
                      onChange={async e => {
                        handleSetting(
                          'pendingTicketPhoneDelay',
                          e.target.value,
                          setPendingTicketPhoneDelay
                        )
                      }}
                    >
                      <MenuItem value={'0'}>0min</MenuItem>
                      <MenuItem value={'5'}>5min</MenuItem>
                      <MenuItem value={'10'}>10min</MenuItem>
                      <MenuItem value={'15'}>15min</MenuItem>
                      <MenuItem value={'30'}>30min</MenuItem>
                      <MenuItem value={'60'}>1H</MenuItem>
                    </SelectInput>
                  </div>
                )}
              </Grid>

              <Grid item xs={12} md={3} className={classes.boxContentGroup}>
                <div style={{ maxWidth: '190px' }}>
                  <SelectInput
                    label="Conexão de envio"
                    value={pendingTicketPhoneConnectionValue}
                    onChange={async e => {
                      handleSetting(
                        'pendingTicketPhoneConnectionId',
                        e.target.value,
                        setPendingTicketPhoneConnectionId
                      )
                    }}
                  >
                    {Array.isArray(whatsApps) &&
                      whatsApps
                        .filter(whatsApp => whatsApp.channel === 'whatsapp')
                        .map(whatsApp => (
                          <MenuItem
                            key={whatsApp.id}
                            value={String(whatsApp.id)}
                          >
                            {whatsApp.name || `Conexão ${whatsApp.id}`}
                            {whatsApp.isDefault ? ' (padrão)' : ''}
                          </MenuItem>
                        ))}
                  </SelectInput>
                </div>
                <HelpText
                  id="pendingTicketPhoneConnectionId-helper"
                  className={classes.helpText}
                >
                  Conexão que será usada para enviar as mensagens de notificação
                  pendente para o telefone dos atendentes. Quando não
                  selecionada, será utilizada a conexão padrão da empresa.
                </HelpText>
              </Grid>

              <Grid item xs={12} md={3} className={classes.boxContentGroup}>
                <InputSwitch
                  label={i18n.t('settings.contactTicketHistory.title')}
                  name="contactTicketHistory"
                  id="contactTicketHistory"
                  checked={contactTicketHistory === 'enabled'}
                  onChange={async e => {
                    await handleSetting(
                      'contactTicketHistory',
                      e.target.checked ? 'enabled' : 'disabled',
                      setContactTicketHistory
                    )
                  }}
                  inputProps={{
                    'aria-describedby': 'contactTicketHistory-helper'
                  }}
                />
                <HelpText
                  id="contactTicketHistory-helper"
                  className={classes.helpText}
                >
                  Exibe, na conversa, as mensagens dos atendimentos anteriores do
                  contato, separadas pelo número do atendimento. Cada atendente vê
                  apenas os atendimentos aos quais tem acesso.
                </HelpText>
              </Grid>
            </Grid>
          </Grid>
        </SectionAccordion>

        <SectionAccordion
          id="panel3"
          title="Ações do Bot"
          expanded={expanded}
          onChange={handleChange}
          classes={classes}
          icon={<Bot />}
        >
          <Grid container>
            <Grid item xs={12} className={classes.boxContentInput}>
              <Grid item xs={12} md={3} className={classes.boxContentGroup}>
                <div className={classes.helpButton}>
                  <InputSwitch
                    label="Bot"
                    checked={activateChatbot === 'enabled'}
                    onChange={e => {
                      handleActivateChatbotSwitch(
                        e.target.checked ? 'enabled' : 'disabled'
                      )
                    }}
                  />
                </div>
                <HelpText
                  id="activateChatbot-helper"
                  className={classes.helpText}
                >
                  Ao ativar você define qual ação tomar em X minutos com
                  atendimentos sem interação.
                </HelpText>

                {activateChatbot === 'enabled' && (
                  <div className={classes.boxInputTransition}>
                    <div className={classes.selectTempo}>
                      <SelectInput
                        label="Tempo"
                        value={chatbotTicketTimeout || '5'}
                        onChange={async e => {
                          handleSetting(
                            'chatbotTicketTimeout',
                            e.target.value,
                            setChatbotTicketTimeout
                          )
                        }}
                      >
                        <MenuItem value={'5'}>5min</MenuItem>
                        <MenuItem value={'10'}>10min</MenuItem>
                        <MenuItem value={'15'}>15min</MenuItem>
                        <MenuItem value={'30'}>30min</MenuItem>
                        <MenuItem value={'60'}>1h</MenuItem>
                      </SelectInput>
                    </div>

                    <div className={classes.selectAcao}>
                      <SelectInput
                        label="Ação"
                        value={chatbotTicketTimeoutAction}
                        onChange={async e => {
                          handleSetting(
                            'chatbotTicketTimeoutAction',
                            e.target.value,
                            setChatbotTicketTimeoutAction
                          )
                        }}
                      >
                        <MenuItem value={'0'}>{'Fechar'}</MenuItem>
                        {queues
                          .filter(queue => !queue.notificationact)
                          .map(queue => (
                            <MenuItem
                              key={queue.id}
                              value={queue.id}
                              className={classes.menuItem}
                            >
                              <MoveRight size={18} /> {queue.name}
                            </MenuItem>
                          ))}
                      </SelectInput>
                    </div>
                  </div>
                )}
              </Grid>

              <Grid item xs={12} md={3} className={classes.boxContentGroup}>
                <div className={classes.helpButton}>
                  <InputSwitch
                    label="Fora do Expediente"
                    checked={activateOutOfHours === 'enabled'}
                    onChange={e => {
                      handleActivateOutOfHours(
                        e.target.checked ? 'enabled' : 'disabled'
                      )
                    }}
                  />
                </div>
                <HelpText
                  id="activeOutOfHours-helper"
                  className={classes.helpText}
                >
                  O Bot notifica que está fora do horário e executa a ação
                  configurada em seguida.
                </HelpText>

                {activateOutOfHours === 'enabled' && (
                  <>
                    <div className={classes.boxInputTransition}>
                      <SelectInput
                        label="Ação"
                        labelId="out-of-hours-action-label"
                        value={outOfHoursAction}
                        onChange={async e => {
                          await handleSetting(
                            'outOfHoursAction',
                            e.target.value,
                            setOutOfHoursAction
                          )
                        }}
                      >
                        <MenuItem value={'pending'}>
                          {i18n.t('settings.outOfHoursAction.options.pending')}
                        </MenuItem>
                        <MenuItem value={'ask'}>
                          {i18n.t('settings.outOfHoursAction.options.ask')}
                        </MenuItem>
                        <MenuItem value={'closed'}>
                          {i18n.t('settings.outOfHoursAction.options.closed')}
                        </MenuItem>
                      </SelectInput>
                    </div>
                    {['pending', 'ask'].includes(outOfHoursAction) && (
                      <QueueDepartmentSelect
                        label="Transferir para"
                        placeholder="Selecione o departamento"
                        isMulti={false}
                        filterByIsBot={true}
                        includeAllOption={false}
                        filterNotificationAct={false}
                        showLeafQueuesOnly={true}
                        disabled={loading}
                        customOptions={outOfHoursQueueOptions}
                        value={outOfHoursQueueValue}
                        onChange={selectedOptions => {
                          const selectedObj =
                            selectedOptions.length > 0
                              ? selectedOptions[0]
                              : null
                          const selectedId = selectedObj
                            ? String(selectedObj.id)
                            : ''

                          handleSetting(
                            'outOfHoursQueueId',
                            selectedId,
                            setOutOfHoursQueueId
                          )
                        }}
                      />
                    )}
                  </>
                )}
              </Grid>

              <Grid item xs={12} md={3} className={classes.boxContentGroup}>
                <InputSwitch
                  label={i18n.t('settings.AutomaticChatbotOutput.title')}
                  name="chatbotAutoExit"
                  id="chatbotAutoExit"
                  checked={chatbotAutoExit === 'enabled'}
                  onChange={e => {
                    handleChatbotAutoExit(
                      e.target.checked ? 'enabled' : 'disabled'
                    )
                  }}
                />
                <HelpText
                  id="chatbotAutoExit-helper"
                  className={classes.helpText}
                >
                  Ao responder um opção inválida do menu, encerra a automação do
                  bot e passa o atendimento para pendente.
                </HelpText>

                {chatbotAutoExit === 'enabled' && (
                  <div className={classes.boxInputTransition}>
                    <SelectInput
                      label="Departamento de destino"
                      value={
                        chatbotAutoExitQueueId ||
                        (chatbotAutoExitQueues[0]
                          ? String(chatbotAutoExitQueues[0].id)
                          : '')
                      }
                      onChange={async e => {
                        handleSetting(
                          'chatbotAutoExitQueueId',
                          String(e.target.value),
                          setChatbotAutoExitQueueId
                        )
                      }}
                    >
                      {chatbotAutoExitQueues.map(queue => (
                        <MenuItem key={queue.id} value={String(queue.id)}>
                          {queue.name}
                        </MenuItem>
                      ))}
                    </SelectInput>

                    <SelectInput
                      label="Qtd. de respostas erradas"
                      value={chatbotAutoExitAttempts || '1'}
                      onChange={async e => {
                        handleSetting(
                          'chatbotAutoExitAttempts',
                          String(e.target.value),
                          setChatbotAutoExitAttempts
                        )
                      }}
                    >
                      {Array.from({ length: 10 }, (_, index) => {
                        const value = String(index + 1)
                        return (
                          <MenuItem key={value} value={value}>
                            {value}
                          </MenuItem>
                        )
                      })}
                    </SelectInput>
                  </div>
                )}
              </Grid>


            </Grid>
          </Grid>
        </SectionAccordion>

        <SectionAccordion
          id="panel4"
          title="Grupos do WhatsApp"
          expanded={expanded}
          onChange={handleChange}
          classes={classes}
          icon={<Users />}
        >
          <Grid
            container
            spacing={2}
            className={classes.boxContentInputMessage}
          >
            <Grid item xs={12} className={classes.boxContentInputMessage}>
              <Grid item xs={12} md={4} className={classes.boxContentGroup}>
                <InputSwitch
                  label="Receber Mensagens"
                  name="group-type-label"
                  id="group-type-label"
                  checked={CheckMsgIsGroup === 'disabled'}
                  onChange={e => {
                    handleGroupType(e.target.checked ? 'disabled' : 'enabled')
                  }}
                />
                <HelpText
                  id="checkMsgIsGroup-helper"
                  className={classes.helpText}
                >
                  Ao ativar, exibe a aba de grupos e recebe mensagens. Quando
                  desativado, oculta a aba e bloqueia a exibição de mensagens de
                  grupo no atendimento padrão.
                </HelpText>
              </Grid>
              <Grid item xs={12} md={4} className={classes.boxContentGroup}>
                <InputSwitch
                  label={i18n.t('settings.soundGroupNotifications.title')}
                  name="soundGroupNotifications"
                  id="soundGroupNotifications"
                  checked={soundGroupNotifications === 'enabled'}
                  onChange={e => {
                    handleSetting(
                      'soundGroupNotifications',
                      e.target.checked ? 'enabled' : 'disabled',
                      setSoundGroupNotifications
                    )
                  }}
                />
                <HelpText
                  id="soundGroupNotifications-helper"
                  className={classes.helpText}
                >
                  Ao ativar a notificação sonora irá notificar as novas
                  mensagens recebidas dos grupos.
                </HelpText>
              </Grid>
              <Grid item xs={12} md={4} className={classes.boxContentGroup}>
                <InputSwitch
                  label={i18n.t('settings.groupsTab.title')}
                  name="groupsTab"
                  id="groupsTab"
                  checked={groupsTab === 'enabled'}
                  disabled={CheckMsgIsGroup === 'enabled'}
                  onChange={e => {
                    handleSetting(
                      'groupsTab',
                      e.target.checked ? 'enabled' : 'disabled',
                      setGroupsTab
                    )
                  }}
                />
                <HelpText id="tabGroups-helper" className={classes.helpText}>
                  Ao ativar exibe a aba de grupos (se não estiver configurado
                  para exibir, as mensagens do grupo vão ser
                  tratados como pendente).
                </HelpText>
              </Grid>
            </Grid>
          </Grid>
        </SectionAccordion>

        <SectionAccordion
          id="panel5"
          title={i18n.t('settings.group.confidenciality')}
          expanded={expanded}
          onChange={handleChange}
          classes={classes}
          icon={<Tag />}
        >
          <Grid
            container
            spacing={2}
            className={classes.boxContentInputMessage}
          >
            <Grid item xs={12} className={classes.boxContentInputMessage}>
              <Grid item xs={12} md={4} className={classes.boxContentGroup}>
                <InputSwitch
                  label={i18n.t('settings.messageVisibility.title')}
                  name="messageVisibility"
                  id="messageVisibility"
                  checked={messageVisibility === 'message'}
                  onChange={async e => {
                    await handleSetting(
                      'messageVisibility',
                      e.target.checked ? 'message' : 'ticket',
                      setMessageVisibility
                    )
                  }}
                />
                <HelpText
                  id="messageVisibility-helper"
                  className={classes.helpText}
                >
                  Determina o acesso ao histórico após a transferência. Se
                  ativado, a visibilidade é restrita a participantes prévios. Se
                  desativado, o histórico é liberado integralmente ao novo
                  atendente.
                </HelpText>
              </Grid>
              <Grid item xs={12} md={4} className={classes.boxContentGroup}>
                <InputSwitch
                  label={i18n.t('settings.keepQueueAndUser.title')}
                  name="keepQueueAndUser"
                  id="keepQueueAndUser"
                  checked={keepUserAndQueue === 'enabled'}
                  onChange={async e => {
                    await handleSetting(
                      'keepUserAndQueue',
                      e.target.checked ? 'enabled' : 'disabled',
                      setKeepUserAndQueue
                    )
                  }}
                />
                <HelpText
                  id="keepUserAndQueue-helper"
                  className={classes.helpText}
                >
                  Apos fechar o atendimento, vai manter os campos de departamento e
                  usuário no atendimento.
                </HelpText>
              </Grid>
              <Grid item xs={12} md={4} className={classes.boxContentGroup}>
                <InputSwitch
                  label={i18n.t('settings.requireClosingReason.title')}
                  name="requireClosingReason"
                  id="requireClosingReason"
                  checked={requireClosingReason === 'enabled'}
                  onChange={async e => {
                    await handleSetting(
                      'requireClosingReason',
                      e.target.checked ? 'enabled' : 'disabled',
                      setRequireClosingReason
                    )
                  }}
                />
                <HelpText
                  id="requeriClosingReason-helper"
                  className={classes.helpText}
                >
                  Pergunta o motivo da finalização ao finalizar um atendimento.
                </HelpText>
              </Grid>
            </Grid>
          </Grid>
        </SectionAccordion>

        <SectionAccordion
          id="panel6"
          title="Serviços com IA"
          expanded={expanded}
          onChange={handleChange}
          classes={classes}
          icon={<Sparkles />}
          extraHeader={
            <Tooltip
              title={
                externalServicesLocked
                  ? 'Desbloquear Campos'
                  : 'Bloquear Campos'
              }
              arrow
            >
              <IconButton
                size="small"
                onClick={e => {
                  e.stopPropagation()
                  setExternalServicesLocked(!externalServicesLocked)
                }}
                className={classes.iconLock}
              >
                {externalServicesLocked ? (
                  <Lock size={20} />
                ) : (
                  <Unlock size={20} />
                )}
              </IconButton>
            </Tooltip>
          }
        >
          <Grid item xs={12} className={classes.boxContentInput}>
            <Grid item xs={12} sm={4} md={3} className={classes.groupInput}>
              <SelectInput
                label="Provedor"
                id="aiProvider"
                value={aiProvider}
                disabled={externalServicesLocked}
                onChange={async e => {
                  handleSetting('aiProvider', e.target.value, setAiProvider)
                }}
              >
                <MenuItem value="openai">OpenAI</MenuItem>
                <MenuItem value="groq">Groq</MenuItem>
              </SelectInput>
              {aiProvider && (
                <Tooltip
                  title={`Acessar ${aiProvider === 'openai' ? 'OpenAI' : 'Groq'
                    }`}
                >
                  <div style={{ display: 'inline-block' }}>
                    <IconButton
                      size="small"
                      className={classes.iconButtonLink}
                      disabled={externalServicesLocked}
                      onClick={() => {
                        const url =
                          aiProvider === 'openai'
                            ? 'https://platform.openai.com/'
                            : 'https://console.groq.com/'
                        window.open(url, '_blank')
                      }}
                    >
                      {/* Usando o ícone Settings (faGears) para representar o acesso às configurações/console */}
                      <ExternalLink />
                    </IconButton>
                  </div>
                </Tooltip>
              )}
            </Grid>

            <Grid item xs={12} sm={8} md={6}>
              <InputFieldText
                id="apiKey"
                label="API Key"
                value={openAiKey}
                type={externalServicesLocked ? 'password' : 'text'}
                disabled={externalServicesLocked}
                onChange={e => {
                  setOpenAiKey(e.target.value)
                }}
                onBlur={async _ => {
                  await handleSetting('openAiKey', openAiKey)
                }}
                InputProps={{
                  endAdornment: (
                    <>
                      <Tooltip title="Copiar">
                        <div style={{ display: 'inline-block' }}>
                          <IconButton
                            size="small"
                            className={classes.iconButton}
                            disabled={externalServicesLocked}
                            onClick={() => {
                              navigator.clipboard.writeText(openAiKey)
                              toast.success('Chave de API copiada!')
                            }}
                          >
                            <Files size={20} />
                          </IconButton>
                        </div>
                      </Tooltip>
                    </>
                  )
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} className={classes.alignCenter}>
              <InputSwitch
                label="Transcrição de Audio"
                name="audioTranscriptions"
                id="audioTranscriptions"
                disabled={externalServicesLocked}
                checked={audioTranscriptions === 'enabled'}
                onChange={async e => {
                  await handleSetting(
                    'audioTranscriptions',
                    e.target.checked ? 'enabled' : 'disabled',
                    setAudioTranscriptions
                  )
                }}
              />
            </Grid>
          </Grid>
        </SectionAccordion>

        <SectionAccordion
          id="panel7"
          title={i18n.t('settings.schedules.title')}
          expanded={expanded}
          onChange={handleChange}
          classes={classes}
          icon={<Clock />}
        >
          <SchedulesForm
            loading={loading}
            onSubmit={handleSubmitSchedules}
            initialValues={schedules}
            settings={settings}
            onScheduleTypeChange={handleScheduleTypeChange}
          />
        </SectionAccordion>

        {currentUser?.profile === 'admin' && (
          <SectionAccordion
            id="panel8"
            title="Chave Pix da Empresa"
            expanded={expanded}
            onChange={handleChange}
            classes={classes}
            icon={<Key />}
          >
            <CompanyPixSettings
              settings={settings}
              currentUser={currentUser}
              update={update}
              classes={classes}
              pixSaving={loading}
              setPixSaving={setLoading}
            />
          </SectionAccordion>
        )}

        {isSuperUser && (
          <SectionAccordion
            id="panel9"
            title="Reconexão Automática (WhatsApp)"
            expanded={expanded}
            onChange={handleChange}
            classes={classes}
            icon={<RefreshCw />}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className={classes.helpButton}>
                  <InputSwitch
                    label="Ativar"
                    checked={stuckAckWatchdogEnabled === 'enabled'}
                    onChange={e => {
                      handleSetting(
                        'stuckAckWatchdogEnabled',
                        e.target.checked ? 'enabled' : 'disabled',
                        setStuckAckWatchdogEnabled
                      )
                    }}
                    inputProps={{
                      'aria-describedby': 'stuckAckWatchdog-helper'
                    }}
                  />
                </div>
                <HelpText id="stuckAckWatchdog-helper" className={classes.helpText}>
                  Quando uma mensagem enviada fica presa em "1 check" (não
                  confirmada como entregue), o sistema tenta reconectar a sessão
                  automaticamente, sem precisar reler o QR Code, e reenvia a
                  mesma mensagem assim que a conexão voltar. Desative para
                  impedir que o sistema faça isso automaticamente.
                </HelpText>
              </Grid>

              {stuckAckWatchdogEnabled === 'enabled' && (
                <>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputFieldText
                      label="Idade mínima (min)"
                      type="number"
                      value={stuckAckMinAgeMinutes}
                      onChange={e => setStuckAckMinAgeMinutes(e.target.value)}
                      onBlur={async () => {
                        await handleSetting(
                          'stuckAckMinAgeMinutes',
                          stuckAckMinAgeMinutes
                        )
                      }}
                    />
                    <HelpText
                      id="stuckAckMinAgeMinutes-helper"
                      className={classes.helpText}
                    >
                      Tempo mínimo (em minutos) que uma mensagem precisa estar
                      presa em "1 check" antes de ser considerada suspeita.
                      Evita agir sobre mensagens que ainda podem entregar
                      normalmente.
                    </HelpText>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <InputFieldText
                      label="Idade máxima (min)"
                      type="number"
                      value={stuckAckMaxAgeMinutes}
                      onChange={e => setStuckAckMaxAgeMinutes(e.target.value)}
                      onBlur={async () => {
                        await handleSetting(
                          'stuckAckMaxAgeMinutes',
                          stuckAckMaxAgeMinutes
                        )
                      }}
                    />
                    <HelpText
                      id="stuckAckMaxAgeMinutes-helper"
                      className={classes.helpText}
                    >
                      Tempo máximo (em minutos) que uma mensagem travada ainda é
                      considerada relevante. Mensagens mais antigas que isso são
                      ignoradas, pois o problema provavelmente já não é atual.
                    </HelpText>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <InputFieldText
                      label="Intervalo entre reconexões (min)"
                      type="number"
                      value={stuckAckRefreshCooldownMinutes}
                      onChange={e =>
                        setStuckAckRefreshCooldownMinutes(e.target.value)
                      }
                      onBlur={async () => {
                        await handleSetting(
                          'stuckAckRefreshCooldownMinutes',
                          stuckAckRefreshCooldownMinutes
                        )
                      }}
                    />
                    <HelpText
                      id="stuckAckRefreshCooldownMinutes-helper"
                      className={classes.helpText}
                    >
                      Tempo mínimo (em minutos) entre duas reconexões
                      automáticas da mesma conexão. Evita reconectar
                      repetidamente em um curto intervalo.
                    </HelpText>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <InputFieldText
                      label="Espera pela reconexão (seg)"
                      type="number"
                      value={stuckAckReconnectWaitSeconds}
                      onChange={e =>
                        setStuckAckReconnectWaitSeconds(e.target.value)
                      }
                      onBlur={async () => {
                        await handleSetting(
                          'stuckAckReconnectWaitSeconds',
                          stuckAckReconnectWaitSeconds
                        )
                      }}
                    />
                    <HelpText
                      id="stuckAckReconnectWaitSeconds-helper"
                      className={classes.helpText}
                    >
                      Quanto tempo (em segundos) aguardar a reconexão terminar
                      antes de reenviar as mensagens travadas.
                    </HelpText>
                  </Grid>
                </>
              )}
            </Grid>
          </SectionAccordion>
        )}
      </Grid>
    </>
  )
}
